
import { VendorProfile, Ad, SubscriptionPlan, Neighborhood } from "../types";

export function calculateCurrentMetrics(vendors: VendorProfile[], ads: Ad[], neighborhoods: Neighborhood[]) {
  const total_vendors = vendors.length;
  const proVendors = vendors.filter(v => v.plan === SubscriptionPlan.PRO);
  
  const total_pro_vendors = proVendors.length;
  const total_revenue = total_pro_vendors * 149.90; // Exemplo de ticket médio PRO
  
  const total_whatsapp_clicks = ads.reduce((acc, curr) => acc + (curr.clicks || 0), 0);
  const total_views = ads.reduce((acc, curr) => acc + (curr.views || 0), 0);
  
  const lgr = total_views > 0 ? (total_whatsapp_clicks / total_views) * 100 : 0;
  const total_ads = ads.length;
  
  const adsWithPrice = ads.filter(a => a.price && a.price > 0);
  const avg_price = adsWithPrice.length > 0 ? (adsWithPrice.reduce((acc, a) => acc + (a.price || 0), 0) / adsWithPrice.length) : 0;

  const active_vendors = vendors.filter(v => ads.some(a => a.vendor_id === v.id && a.is_active)).length;
  const activity_rate = total_vendors > 0 ? (active_vendors / total_vendors) * 100 : 0;

  const ads_no_clicks = ads.filter(a => (a.views || 0) > 10 && (a.clicks || 0) === 0).length;
  const churn_rate = 0; 
  const arpu = total_vendors > 0 ? total_revenue / total_vendors : 0;

  const neighborhoodRanking = neighborhoods.map(n => {
    const vendorIdsInNeigh = vendors.filter(v => v.neighborhood_id === n.id).map(v => v.id);
    // Use vendor_id as mapped in App.tsx from vendedor_id in DB
    const count = ads.filter(a => vendorIdsInNeigh.includes(a.vendor_id)).length;
    return { name: n.name, count };
  }).sort((a, b) => b.count - a.count);

  const top_5_neighborhoods = neighborhoodRanking.slice(0, 5);
  const featured_neighborhood = neighborhoodRanking[0]?.name || "N/A";

  return {
    total_vendors,
    total_pro_vendors,
    total_revenue,
    total_whatsapp_clicks,
    lgr,
    total_views,
    total_ads,
    avg_price,
    activity_rate,
    ads_no_clicks,
    churn_rate,
    arpu,
    top_5_neighborhoods,
    featured_neighborhood
  };
}
